<template>
  <b-card header-text-variant="dark">
      <div slot="header">
          <context-header :title="$t('groupSettlement.groupSettlementRegister')">
          </context-header>
      </div>
      <form @submit.stop.prevent="validateAndSubmit" ref="registerGroupSettlementForm">
          <b-card class="mb-2">
              <b-row>
                  <b-col col>
                      <b-form-fieldset :label="$t('groupSettlement.groupSettlementNumber')">
                          <b-form-input
                              v-model="groupSettlement.groupSettlementNumber"
                              name="groupSettlement.groupSettlementNumber"
                              :class="{ 'error': $v.groupSettlement.groupSettlementNumber.$error }"/>
                      </b-form-fieldset>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col col>
                      <b-form-fieldset :label="$t('groupSettlement.massInput')">
                          <b-form-textarea
                              :rows="15"
                              :max-rows="32"
                              v-model="massInput"
                              :class="{ 'error': $v.massInput.$error }"
                              class="monospace-input"/>
                      </b-form-fieldset>
                  </b-col>
              </b-row>
              <b-card no-body header-bg-variant="danger"
                :header="$t('groupSettlement.massInputError.tableHeader')"
                header-text-variant="white"
                  v-if="showErrorContainer"
                  class="m-1">
                <div class="list-container">
                  <b-list-group>
                    <b-list-group-item :key="error" v-for="error in errorList">{{error}}</b-list-group-item>
                  </b-list-group>
                </div>
              </b-card>
              <div slot="footer" class="text-right">
                  <b-button v-b-modal.registerSingleConfirmationModal variant="primary" :disabled="load">
                      {{ $t('groupSettlement.groupSettlementSubmit') }}
                      <loader :show="load" type="button"></loader>
                  </b-button>
              </div>
          </b-card>
          <div>
              <b-modal id="registerSingleConfirmationModal" @ok="validateAndSubmit" :ok-title="$t('forms.submit')" :cancel-title="$t('forms.cancel')">
                  {{ $t('groupSettlement.groupSettlementConfirmation') }}
              </b-modal>
          </div>
      </form>
  </b-card>
</template>
<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Vuelidate from 'vuelidate'
  import { validationMixin } from '@/mixins/validation'
  import { MassInputValidator } from '../validators'
  import { massInputValidationMixin } from '../validators/mixin'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import { required } from 'vuelidate/lib/validators'
  import Loader from '@/components/misc/Loader'

  Vue.use(Vuelidate)

  export default {
    mixins: [validationMixin, massInputValidationMixin],
    components: {
      Loader,
      ContextHeader
    },
    data () {
      return {
        load: false,
        currency: {
          decimal: this.$store.getters.decimalFormat,
          thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        errorList: [],
        groupSettlement: {
          groupSettlementNumber: '',
          groupSettlementItems: []
        },
        massInput: '',
        registerGroupSettlementLink: Vue.$apiConfig.registerGroupSettlementPost
      }
    },
    computed: {
      showErrorContainer () {
        return this.errorList && this.errorList.length > 0
      }
    },
    methods: {
      validateAndSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('errors.someErrorsOccuredCheckListBelow'),
            errors: this.getValidationErrors('groupSettlement')
          })
          if (this.$v.massInput.$invalid) {
            this.errorList = this.getMassInputErrors(this.massInput)
          }
        } else {
          this.errorList = []
          this.submitGroupSettlement()
        }
      },
      submitGroupSettlement: function (e) {
        this.logConsole('Submitting Group Settlement')
        this.load = true
        this.parseMassInput(this.massInput).forEach(row => {
          if (row === '') {
            return
          }
          let temp = row.match(/\S+/g)
          let invoiceId = temp[0]
          let amount = temp[1] ? Number(temp[1]) : 0
          this.groupSettlement.groupSettlementItems.push({InvoiceId: invoiceId, SettlementAmount: amount})
        })
        this.$http.post(this.registerGroupSettlementLink, this.groupSettlement)
        .then(response => {
          this.logConsole(response)
          let responseData = response.data.payload.groupSettlement
          this.load = false
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('groupSettlement.groupSettlementRegistered') + ' - ',
            link: '/group-settlement/' + responseData.groupSettlementId,
            linkDescription: responseData.groupSettlementNumber,
            errors: []
          })
          this.$nextTick(function () {
            document.body.scrollTop = 0 // safari
            document.documentElement.scrollTop = 0 // chrome, ie, ff
          })
          this.groupSettlement.groupSettlementItems = []
          this.groupSettlement.groupSettlementNumber = ''
          this.massInput = ''
          this.$refs.registerGroupSettlementForm.reset()
          this.$v.$reset()
        }, error => {
          if (typeof error.body.payload !== 'undefined' && error.body.payload !== null) {
            if (typeof error.body.payload.groupSettlementItems !== 'undefined') {
              let localErrorList = []
              Array.from(error.body.payload.groupSettlementItems).forEach(row => {
                if (typeof row.groupSettlementItemError !== 'undefined') {
                  let errorPrefix = this.$t('groupSettlement.massInputError.returnedCodePrefix', [row.groupSettlementItem.invoiceId])
                  let errorMsg = this.$t('apiStatusCodes.' + row.groupSettlementItemError.code)
                  if (row.groupSettlementItem.groupSettlementId) {
                    errorMsg += ' - ' + row.groupSettlementItem.groupSettlementId
                  }
                  localErrorList.push(errorPrefix + ' ' + errorMsg)
                }
              })
              this.errorList.push(...localErrorList)
            }
          }
          this.load = false
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.groupSettlement.groupSettlementItems = []
        })
      }
    },
    validations: {
      massInput: {
        MassInputValidator: MassInputValidator({minimumInvoices: 2})
      },
      groupSettlement: {
        groupSettlementNumber: {
          required
        }
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';
  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }

  .monospace-input {
    font-family:monospace;
  }

</style>



// WEBPACK FOOTER //
// RegisterGroupSettlement.vue?358793ee